/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */
export const baggageEntryMetadataSymbol = Symbol('BaggageEntryMetadata');
